import { getBrowserLanguage } from "./language";
export var percentFormatter = function (value) {
    return new Intl.NumberFormat(undefined, {
        style: "percent",
    }).format(value);
};
export var convertCentsToUnit = function (value) { return value / 100; };
export var formatTextToCNPJ = function (value) {
    var cnpjMask = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;
    return value.trim().replace(cnpjMask, "$1.$2.$3/$4-$5");
};
export var formatTextToCPF = function (value) {
    var cnpjMask = /^(\d{3})(\d{3})(\d{3})(\d{2})/;
    return value.trim().replace(cnpjMask, "$1.$2.$3-$4");
};
export var formatCurrency = function (value, _a) {
    var _b = _a.convertFromCents, convertFromCents = _b === void 0 ? true : _b, _c = _a.locales, locales = _c === void 0 ? [getBrowserLanguage()] : _c, _d = _a.currencyCode, currencyCode = _d === void 0 ? "USD" : _d;
    var formattedValue = convertFromCents ? convertCentsToUnit(value) : value;
    return new Intl.NumberFormat(locales, {
        currency: currencyCode,
        style: "currency",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(formattedValue);
};
export var cpfMask = [
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
];
export var cnpjMask = [
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    "/",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
];
export var cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
